// extracted by mini-css-extract-plugin
export default {"questionText":"questionText__Ek1tV"};